import React, { useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import { FormikRadioGroup } from './FormikRadioGroup';
import { Box } from '@material-ui/core';
import type { FormField } from '../interfaces';
import { findCamundaValidation, getLocalizedLabel } from '../utils';
import { LinkSelector } from './LinkSelector';
import { getFormFieldStyles } from '../formFieldStyles';

export const ConditionalLinkSelector = ({
    conditionalFieldId,
    isRequired,
    isReadOnly,
    field,
    fields,
    locale,
}: {
    conditionalFieldId: string;
    isRequired?: boolean;
    isReadOnly?: boolean;
    field?: FormField;
    fields?: Array<FormField>;
    locale: string;
}) => {
    const classes = getFormFieldStyles();
    const { setFieldValue } = useFormikContext();
    const [toggleFormikField] = useField(field?.id as string);
    const [conditionalFormikField, conditionalFormikMeta] =
        useField(conditionalFieldId);

    const conditionalField = fields?.find(
        (f) => f.id === conditionalFormikField?.name,
    );

    const [showConditionalField, setShowConditionalField] = useState(undefined);

    const conditionalFieldIsRequiredValidation = findCamundaValidation(
        'required',
        conditionalField?.validation,
    );

    const conditionalFieldIsRequired =
        conditionalFieldIsRequiredValidation &&
        (showConditionalField || toggleFormikField?.value === 'true');

    const conditionalFieldIsReadOnly = findCamundaValidation(
        'readonly',
        conditionalField?.validation,
    );

    useEffect(() => {
        if (
            toggleFormikField?.value === 'false' ||
            showConditionalField === false
        ) {
            if (
                !conditionalField?.value &&
                conditionalFieldIsRequiredValidation
            ) {
                setFieldValue(conditionalField?.id as string, 0);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggleFormikField?.value, showConditionalField]);

    return (
        <Box className={classes.container}>
            <FormikRadioGroup
                {...toggleFormikField}
                id={field?.id}
                label={getLocalizedLabel(
                    `project.formFields.${field?.id}`,
                    field?.label,
                    field?.id,
                )}
                isRequired={isRequired}
                isReadOnly={isReadOnly}
                callback={setShowConditionalField}
                locale={locale}
            />
            {showConditionalField ||
            toggleFormikField?.value === 'true' ||
            (conditionalFormikMeta.touched &&
                Boolean(conditionalFormikMeta.error)) ? (
                <LinkSelector
                    field={conditionalField}
                    isRequired={conditionalFieldIsRequired}
                    isReadOnly={isReadOnly || conditionalFieldIsReadOnly}
                />
            ) : null}
        </Box>
    );
};
